import { Component, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LineLovDialogComponent } from '../../common/line-lov-dialog/line-lov-dialog.component';
import { IssSrcComponent } from '../../common/iss-src/iss-src.component';
import { PerilLovComponent } from '../../common/peril-lov/peril-lov.component';
import { ContractTypeLovDialogComponent } from '../../common/contract-type-lov/contract-type-lov.component';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { DialogBoxService } from 'src/app/services/dialog-box.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { forkJoin, Observable } from 'rxjs';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { SecurityService } from 'src/app/services/security.service'; 
import { PlanLovComponent } from '../../common/plan-lov/plan-lov.component';
import { DeductibleLovDialog } from '../../common/deductible-lov-dialog/deductible-lov-dialog.component';
@Component({
  selector: 'applicable-deductible-per-plan-maintenance',
  templateUrl: './applicable-deductible-per-plan-maintenance.component.html',
  styleUrls: ['./applicable-deductible-per-plan-maintenance.component.css']
})
export class ApplicableDeductiblePerPlanMaintenanceComponent implements OnInit, LeaveConfirmation {
  
  datePipe = new DatePipe('en-us');

  addDisabled : boolean = false;
  saveDisabled : boolean = true;
  deleteDisabled : boolean = true;
  tranPosted : boolean = false;
  noLoadingInProcess : boolean = true;
  validated : boolean = false;
  userIDReadOnly : boolean = false;
  isLineSelected : boolean = false;
  pubUserStdRatesCodeField: string = '';
  currentUser: string = this.jsonDataService.retrieveFromStorage('userId');
  rowClickedData: any;
  selectedData : any = null;
  moduleId: string = 'BMM140';
  sublineDisabled: boolean = true;
  planDisabled:boolean = true;
  moduleName: string = '';
  selectedLine: any = {
    LINE_CD: '',
    LINE_NAME: '',
    LINE_FIELD: ''
  };

  selectedSubline: any = {
    SUBLINE_CD: '',
    SUBLINE_NAME: '',
    SUBLINE_FIELD: ''
  };

  selectedPlan: any = {
    PLAN_CD: '',
    PLAN_NAME: '',
    PLAN_FIELD: ''
  };

  selectedDeductible: any = {
    DEDUCTIBLE_CD: '',
    DEDUCTIBLE_TITLE: '',
    DEDUCTIBLE_FIELD: ''
  };

  tempAddedData: any = [];
  tempUpdateData: any = [];
  deductibleTypeList: any = [];
  rangeSwitchList: any = [];

  paramForm = this.formBuilder.group({
    lineCd: [null],
    lineName: [null],
    lineField: [null],
    sublineCd: [null],
    sublineName: [null],
    sublineField: [null],
    planCd: [null],
    planName: [null],
    planField: [null],
  });
  deductibleForm = this.formBuilder.group({
    deductibleCd: [null],
    deductibleField:[null,[Validators.required]],
    deductibleTitle: [null],
    activeTag: ['A', [Validators.required]],
    remarks: [null],
    userID: [null],
    lastUserUpdate: [null]
  });

  constructor(
    private apiCallService: APICallService,
    public _Dialog: MatDialog, 
    private userDetailService: UserDetailsService,
    private formService: FormService, 
    private formBuilder: FormBuilder, 
    private appMessageService: AppMessageService,
    private jsonDataService: JsonDataService,
    private securityService: SecurityService
  ) {  
    let moduleLists = JSON.parse(this.jsonDataService.decrypt(sessionStorage.getItem("mdls") || "")); 
    this.moduleName = moduleLists.filter((data: any) => { return data.moduleId === this.moduleId })[0].moduleDesc.toUpperCase();
    this.deductibleTypeList = this.jsonDataService.data.refCds.filter((e: any) => e.rvDomain=="DEDUCTIBLE_TYPE");
    this.rangeSwitchList = this.jsonDataService.data.refCds.filter((e: any) => e.rvDomain=="RANGE_SW");
  }

  canDeactivate(): Observable<boolean> | boolean {
    if(this.tempAddedData!='' || this.tempUpdateData!='') {
      return false;
    } else {
      return true;
    }
  }

  deductibleTblConfig: any = {
    cols: [
      {
        key: "DEDUCTIBLE_CD",
        header: "Deductible Code",
        dataType: "string",
        width: '25%'
      },
      {
        key: "DEDUCTIBLE_TITLE",
        header: "Deductible",
        dataType: "string"
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '10%'
      }
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }
  ngOnInit() {
  }

  initOnGet(): void {
    try {
      this.apiCallService.refreshNeeded$
            .subscribe(() => {
              this.getAllDeductible();
          });
      this.getAllDeductible();
    }
    catch(e) {
    }
  }

  async getAllDeductible(){
    try{
      let lineCd = this.paramForm.get('lineCd')?.value;
      let sublineCd = this.paramForm.get('sublineCd')?.value;
      let planCd = this.paramForm.get('planCd')?.value;
      if (lineCd && sublineCd && planCd) {
        const params = {
          queryParams:{
            lineCd: lineCd,
            sublineCd: sublineCd,
            planCd: planCd
          },
          moduleId: this.moduleId,
          userId: this.userDetailService.userId,
          type: "MODULE"
        }
        this.deductibleTblConfig.loading = true;
        this.apiCallService.getApplicableDeductiblePerPlan(params).subscribe({
          next: (data: any) => {
            this.securityService.checkRequestKeyResponse(data, ()=>{
              this.securityService.hasValidCsrfToken(data, ()=>{
                data = JSON.parse(this.jsonDataService.decrypt(data.response));
                let rawData:any = [];
                let finalData:any = [];
                if(!Array.isArray(data)){
                  rawData.push(data);
                }
                else{
                  rawData = data;
                }
                
                // finalData = this.populateTempData(finalData, rawData);
                if(rawData.length>0){
                  for(let item of rawData){
                    item.DEDUCTIBLE_FIELD = item.DEDUCTIBLE_CD +" - "+ item.DEDUCTIBLE_TITLE;
                  }
                }
                this.deductibleTblConfig.tblData = rawData;
                this.deductibleTblConfig.loading = false;
                this.tempAddedData = [];
                this.tempUpdateData = [];
                this.saveDisabled = this.saveChecker();
              });
            })
          },
          error: (e: any) => {
            this.deductibleTblConfig.loading = false;
          }
        });
      } else{
        this.deductibleTblConfig.loading = true;
        this.deductibleTblConfig.tblData = [];
        this.deductibleTblConfig.loading = false;
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }catch(e){
    }
  }

  updateLine() {
    try {
      this.tranPosted = true;
      this.validateUpdate();
      if (this.validated) {
        this.updateFormTable();
      }
    }
    catch(e) {
    }
  }

  updateFormTable() {
    try {
      let tempInsertChecker = this.tempAddedData.find((line: { DEDUCTIBLE_CD:any }) => 
        line.DEDUCTIBLE_CD == this.deductibleForm.get('deductibleCd')?.value
      );
      let tempUpdateChecker = this.tempUpdateData.find((line: { DEDUCTIBLE_CD:any }) => 
        line.DEDUCTIBLE_CD == this.deductibleForm.get('deductibleCd')?.value
      );
      
      this.tableDataUpdate();
        
      // Adds Updated Data that exists in the database to an object array for updated datas
      let deductibleString = this.deductibleForm.get('deductibleField')?.value.split(" - ");
      let deductibleCd =""
      let deductibleTitle=""
      if(deductibleString.length){
        deductibleCd=deductibleString[0]
        deductibleTitle=deductibleString[1] 
      }
      if(tempInsertChecker!=null && tempInsertChecker!='') {
        //this.tempUpdateData.push(this.formValueToData());
        tempInsertChecker.LINE_CD= this.paramForm.get('lineCd')?.value;
        tempInsertChecker.SUBLINE_CD = this.paramForm.get('sublineCd')?.value;
        tempInsertChecker.PLAN_CD = this.paramForm.get('planCd')?.value;
        tempInsertChecker.DEDUCTIBLE_CD= deductibleCd;
        tempInsertChecker.DEDUCTIBLE_TITLE= deductibleTitle;
        tempInsertChecker.DEDUCTIBLE_FIELD= this.deductibleForm.get('deductibleField')?.value;
        tempInsertChecker.ACTIVE_TAG = this.deductibleForm.get('activeTag')?.value;
        tempInsertChecker.REMARKS = this.deductibleForm.get('remarks')?.value;
        tempInsertChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.deductibleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempInsertChecker.USER_ID = this.deductibleForm.get('userID')?.value;
        tempInsertChecker.MODE = 'I';
      } 
      else if(tempUpdateChecker!=null && tempUpdateChecker!='') {
        tempUpdateChecker.LINE_CD= this.paramForm.get('lineCd')?.value;
        tempUpdateChecker.SUBLINE_CD = this.paramForm.get('sublineCd')?.value;
        tempUpdateChecker.PLAN_CD = this.paramForm.get('planCd')?.value;
        tempUpdateChecker.DEDUCTIBLE_CD= deductibleCd;
        tempUpdateChecker.DEDUCTIBLE_TITLE= deductibleTitle;
        tempUpdateChecker.DEDUCTIBLE_FIELD= this.deductibleForm.get('deductibleField')?.value;
        tempUpdateChecker.ACTIVE_TAG = this.deductibleForm.get('activeTag')?.value;
        tempUpdateChecker.REMARKS = this.deductibleForm.get('remarks')?.value;
        tempUpdateChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.deductibleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempUpdateChecker.USER_ID = this.deductibleForm.get('userID')?.value;
        tempUpdateChecker.MODE = 'U';
      }
      else {
        this.tempUpdateData.push(this.formValueToData());
      }
      this.saveDisabled = false;
      this.resetFormValues();
      this.appMessageService.showAppMessage("Standard Rates details updated!", "success");
    }
    catch(e) {
    }
  }

  tableDataUpdate() {
    try {
      this.deductibleForm.patchValue({
        activeTag: this.deductibleForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let updateIndex = this.deductibleTblConfig.tblData.indexOf(this.rowClickedData);
      let deductibleString = this.deductibleForm.get('deductibleField')?.value.split(" - ");
      let deductibleCd =""
      let deductibleTitle=""
      if(deductibleString.length){
        deductibleCd=deductibleString[0]
        deductibleTitle=deductibleString[1] 
      }
      this.deductibleTblConfig.tblData[updateIndex] = {
        LINE_CD: this.paramForm.get('lineCd')?.value,
        SUBLINE_CD: this.paramForm.get('sublineCd')?.value,
        PLAN_CD: this.paramForm.get('planCd')?.value,
        DEDUCTIBLE_CD: deductibleCd,
        DEDUCTIBLE_TITLE: deductibleTitle,
        DEDUCTIBLE_FIELD: this.deductibleForm.get('deductibleField')?.value,
        ACTIVE_TAG: this.deductibleForm.get('activeTag')?.value,
        REMARKS: this.deductibleForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.deductibleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.deductibleForm.get('userID')?.value,
        MODE: 'U'
      };
      this.deductibleTblConfig.tblData = [...this.deductibleTblConfig.tblData];
    }
    catch(e) {
    }
  }

  formValueToData() {
    try {
      let deductibleString = this.deductibleForm.get('deductibleField')?.value.split(" - ");
      let deductibleCd
      let deductibleTitle
      if(deductibleString.length){
        deductibleCd=deductibleString[0]
        deductibleTitle=deductibleString[1] 
      }
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        LINE_CD: this.paramForm.get('lineCd')?.value,
        SUBLINE_CD: this.paramForm.get('sublineCd')?.value,
        PLAN_CD: this.paramForm.get('planCd')?.value,
        DEDUCTIBLE_CD: deductibleCd,
        DEDUCTIBLE_TITLE: deductibleTitle,
        DEDUCTIBLE_FIELD: this.deductibleForm.get('deductibleField')?.value,
        ACTIVE_TAG: this.deductibleForm.get('activeTag')?.value,
        REMARKS: this.deductibleForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.deductibleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.deductibleForm.get('userID')?.value,
        MODE: 'U'
      }
      return formToData;
    }
    catch(e) {
    }
  }
  deleteLine() {
    try {
      let clickData = this.rowClickedData;
      this.deductibleTblConfig.tblData = this.deductibleTblConfig.tblData.filter(
        function(e: any) {
          return e.DEDUCTIBLE_CD !== clickData.DEDUCTIBLE_CD;
        }
      );
      this.tempAddedData = this.tempAddedData.filter(
        function(e: any) {

          return e.DEDUCTIBLE_CD !== clickData.DEDUCTIBLE_CD;
        }
      );
      this.resetFormValues();
    }
    catch(e) {
    }
  }

  insertLine() {
    try {
      this.tranPosted = true;
      this.validateInsert();
      if (this.validated) {
        this.addFormToTable();
      }
    }
    catch(e) {
    }
  }
  addFormToTable() {
    try {
      this.deductibleForm.patchValue({
        activeTag: this.deductibleForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let deductibleField = this.deductibleForm.get('deductibleCd')?.value +" - "+this.deductibleForm.get('deductibleTitle')?.value;
      
      let formToData: any = {
        LINE_CD: this.paramForm.get('lineCd')?.value,
        SUBLINE_CD: this.paramForm.get('sublineCd')?.value,
        PLAN_CD: this.paramForm.get('planCd')?.value,
        DEDUCTIBLE_CD: this.deductibleForm.get('deductibleCd')?.value,
        DEDUCTIBLE_TITLE: this.deductibleForm.get('deductibleTitle')?.value,
        DEDUCTIBLE_FIELD: deductibleField,
        ACTIVE_TAG: this.deductibleForm.get('activeTag')?.value,
        REMARKS: this.deductibleForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.deductibleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.deductibleForm.get('userID')?.value,
        MODE: 'I'
      }
      this.deductibleTblConfig.tblData.unshift(formToData);
      this.deductibleTblConfig.tblData = [...this.deductibleTblConfig.tblData];
      this.tempAddedData.push(formToData);
      this.resetFormValues();
      this.appMessageService.showAppMessage("Standard Rates details added!", "success");
    }
    catch(e) {
    }
  }

  saveData(tempChangeData:any[]){
    this.apiCallService.saveApplicableDeductiblePerPlan(tempChangeData)
    .subscribe({
      next: (response : any) => {
        this.securityService.checkRequestKeyResponse(response, () => {
          this.securityService.hasValidCsrfToken(response, ()=>{
            if (response.status == "SUCCESS" && this.tranPosted) {
              this.openDialog('SUCCESS', 'Details Successfully saved!');
              this.initOnGet();
              this.resetFormValues();
              this.tempAddedData = [];
              this.tempUpdateData = [];
              this.saveDisabled = this.saveChecker();
            }  
            else {
              this.initOnGet();
              this.saveDisabled = this.saveChecker();
              this.openDialog('ERROR', 'An error has occured while saving details');
            }
          });
        });
      }, 
      error: () => {
      }
    });
  }

  toSave() {
    try {
      this.noLoadingInProcess = false;
      this.formService.showFormLoader(null, "generate-line-form", "Please wait ...", null, null);
      let tempChangeData= this.tempAddedData.concat(this.tempUpdateData);
      if(tempChangeData.length!=0) {
        this.saveData(tempChangeData);
      } else {
        this.initOnGet();
        this.resetFormValues();
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }
    catch(e) {
    }
  }
  saveChecker() {
    try {
      if((this.tempAddedData==null || this.tempAddedData=='') && (this.tempUpdateData==null || this.tempUpdateData=='')) {
        return true;
      }
      else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  deleteChecker(ev: any) {
    try {
      let tempDataFlag;
      tempDataFlag = this.tempAddedData.filter(function(e: any) {
        let returnValue = e.DEDUCTIBLE_CD==ev.DEDUCTIBLE_CD
        return returnValue;
      });
      if(tempDataFlag==''||tempDataFlag==null) {
        return true;
      } else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  sublineChecker(){
    try{
      let lineCd = this.paramForm.get('lineCd')?.value;
      if(lineCd!==''&&lineCd!==null){
        return false;
      }
      else{ 
        return true;
      }
    }catch(e){
      return true;
    }
  }

  planChecker(){
    try{
      let lineCd = this.paramForm.get('lineCd')?.value;
      let sublineCd = this.paramForm.get('sublineCd')?.value;
      if(lineCd==''||lineCd==null){
        return true;
      }
      if(sublineCd==''||sublineCd==null){
        return true;
      }
      return false;
    }catch(e){
      return true;
    }
  }
  onRowClick(ev: any) {
    try {    
      if(ev!=null) {
        this.rowClickedData = ev;
        this.deductibleForm.get('lineCode')?.disable();
        this.loadFormValues();
        this.saveDisabled = this.saveChecker();
        this.deleteDisabled = this.deleteChecker(ev);
      }
      else {
        this.resetFormValues();
      }
    }
    catch(e) {
    }
  }

  loadFormValues() {
    try {
      this.deductibleForm.patchValue({
        deductibleCd: this.rowClickedData.DEDUCTIBLE_CD,
        deductibleTitle: this.rowClickedData.DEDUCTIBLE_TITLE,
        deductibleField: this.rowClickedData.DEDUCTIBLE_CD+" - "+this.rowClickedData.DEDUCTIBLE_TITLE,
        activeTag: this.rowClickedData.ACTIVE_TAG,
        remarks: this.rowClickedData.REMARKS,
        userID: this.rowClickedData.USER_ID,
        lastUserUpdate: this.rowClickedData.LAST_USER_UPDATE
      });
      this.addDisabled = true;
      this.userIDReadOnly = true;
      this.isLineSelected = true;
    }
    catch(e) {
    }
  }

  resetFormValues() {
    try {
      this.selectedData = null;
      // this.paramForm.get('lineCD')?.enable();
      this.deductibleForm.patchValue({
        deductibleCd: null,
        deductibleTitle: null,
        deductibleField: null,
        activeTag: 'A',
        remarks: null,
        userID: null,
        lastUserUpdate: null
      });

      this.addDisabled = false;
      this.saveDisabled = this.saveChecker();
      this.deleteDisabled = true;
      this.userIDReadOnly = false;
      this.isLineSelected = false;

      this.rowClickedData = '' || null;
    }
    catch (e) {
    console.error(e);
    }
  }

  openLineDialog() {
    try {
      this._Dialog.open(LineLovDialogComponent, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'LINE',
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedLine = data.content;
          this.paramForm.get('lineCd')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_CD);
          this.paramForm.get('lineName')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_NAME);
          this.paramForm.get('lineField')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_CD + " - " + this.selectedLine.LINE_NAME);
        }
        this.paramForm.get('sublineCd')?.setValue(null);
        this.paramForm.get('sublineName')?.setValue(null);
        this.paramForm.get('sublineField')?.setValue(null);
        this.resetFormValues();
        this.initOnGet();
        this.sublineDisabled = this.sublineChecker();
      });
    } catch(e) {
    }
  }
  openSublineDialog() {
    try {
      this._Dialog.open(LineLovDialogComponent, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'SUBLINE',
          lineCd: this.paramForm.get('lineCd')?.value,
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedSubline = data.content;
          this.paramForm.get('sublineCd')?.setValue(this.selectedSubline.SUBLINE_CD==null || this.selectedSubline.SUBLINE_CD=='' ? '' : this.selectedSubline.SUBLINE_CD);
          this.paramForm.get('sublineName')?.setValue(this.selectedSubline.SUBLINE_CD==null || this.selectedSubline.SUBLINE_CD=='' ? '' : this.selectedSubline.SUBLINE_NAME);
          this.paramForm.get('sublineField')?.setValue(this.selectedSubline.SUBLINE_CD==null || this.selectedSubline.SUBLINE_CD=='' ? '' : this.selectedSubline.SUBLINE_CD+ " - " + this.selectedSubline.SUBLINE_NAME);
        }
        this.paramForm.get('planCd')?.setValue(null);
        this.paramForm.get('planName')?.setValue(null);
        this.paramForm.get('planField')?.setValue(null);
        this.resetFormValues();
        this.initOnGet();
        this.planDisabled = this.planChecker();
      });
    } catch(e) {
    }
  }
  openPlanDialog() {
    try {
      this._Dialog.open(PlanLovComponent, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'PLAN',
          lineCd: this.paramForm.get('lineCd')?.value,
          sublineCd: this.paramForm.get('sublineCd')?.value,
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedPlan = data.content;
          this.paramForm.get('planCd')?.setValue(this.selectedPlan.PLAN_CD==null || this.selectedPlan.PLAN_CD=='' ? '' : this.selectedPlan.PLAN_CD);
          this.paramForm.get('planName')?.setValue(this.selectedPlan.PLAN_CD==null || this.selectedPlan.PLAN_CD=='' ? '' : this.selectedPlan.PLAN_NAME);
          this.paramForm.get('planField')?.setValue(this.selectedPlan.PLAN_CD==null || this.selectedPlan.PLAN_CD=='' ? '' : this.selectedPlan.PLAN_CD+ " - " + this.selectedPlan.PLAN_NAME);
          this.initOnGet();
        }
        this.resetFormValues();
      });
    } catch(e) {
    }
  }
  openDeductibleDialog() {
    try {
      this._Dialog.open(DeductibleLovDialog, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'DEDUCTIBLE',
          lineCd: this.paramForm.get('lineCd')?.value,
          sublineCd: this.paramForm.get('sublineCd')?.value,
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedDeductible = data.content;
          this.deductibleForm.get('deductibleCd')?.setValue(this.selectedDeductible.DEDUCTIBLE_CD==null || this.selectedDeductible.DEDUCTIBLE_CD=='' ? '' : this.selectedDeductible.DEDUCTIBLE_CD);
          this.deductibleForm.get('deductibleTitle')?.setValue(this.selectedDeductible.DEDUCTIBLE_CD==null || this.selectedDeductible.DEDUCTIBLE_CD=='' ? '' : this.selectedDeductible.DEDUCTIBLE_TITLE);
          this.deductibleForm.get('deductibleField')?.setValue(this.selectedDeductible.DEDUCTIBLE_CD==null || this.selectedDeductible.DEDUCTIBLE_CD=='' ? '' : this.selectedDeductible.DEDUCTIBLE_CD+ " - " + this.selectedDeductible.DEDUCTIBLE_TITLE);
        }
      });
    } catch(e) {
    }
  }
  openDialog(title: any, message: any) {
    try {
      this.noLoadingInProcess = true;
      this.formService.hideFormLoader("generate-line-form");
      this._Dialog.open(DialogMsgComponent, { 
        disableClose: true,
        width: "500px",
        data: {
          title: title,
          content: message
        } 
      });
    } catch(e) {
    }
  }

  populateTempData(finalData:any[], rawData:any[]){
    let lineCd = this.paramForm.get('lineCd')?.value;
    let sublineCd = this.paramForm.get('sublineCd')?.value;
    let planCd = this.paramForm.get('planCd')?.value;

    let filteredAddedData: any=[];
    let filteredUpdatedData: any=[];
    if(this.tempUpdateData!=null&&this.tempUpdateData.length!=0){
      filteredUpdatedData = this.tempUpdateData.filter(function(item:any){
        if(item.LINE_CD==lineCd&&item.SUBLINE_CD==sublineCd){
          finalData = rawData.filter(function(rawDataItem:any){
            if(rawDataItem.LINE_CD==lineCd&&rawDataItem.SUBLINE_CD==sublineCd&&rawDataItem.PLAN_CD==planCd&&rawDataItem.DEDUCTIBLE_CD==item.DEDUCTIBLE_CD){
              return false;
            }
            else{
              return true;
            }
          })
          return true;
        }
        else{
          return false;
        }
      })
      if(filteredUpdatedData.length!=0&&filteredUpdatedData!=null){
        finalData = finalData.concat(filteredUpdatedData);
      }
      else{
        finalData = rawData;
      }
    }
    else{
      finalData = rawData;
    }
    
    if(this.tempAddedData!=null&&this.tempAddedData.length!=0){
      filteredAddedData = this.tempAddedData.filter(function(item:any){
        if(item.LINE_CD==lineCd&&item.SUBLINE_CD==sublineCd&&item.PLAN_CD==planCd){
          return true;
        }
        else{
          return false;
        }
      })
      if(filteredAddedData.length!=0&&filteredAddedData!=null){
        finalData = finalData.concat(filteredAddedData);
      }
    }
    if(finalData.length>0){
      for(let item of finalData){
        item.DEDUCTIBLE_FIELD = item.DEDUCTIBLE_CD +" - "+ item.DEDUCTIBLE_TITLE;
      }
    }
    return finalData;
  }
  
  validateInsert() {
    try {
      this.validated = false;
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                           //10 secs countdown
          this.formService.hideFormMsg("bfb-standard-rates-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck()) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("bfb-standard-rates-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  requiredFieldCheck() {
    try {
      if(this.paramForm.get('lineCd')?.value==='' || this.paramForm.get('lineCd')?.value===null
        ||this.paramForm.get('sublineCd')?.value==='' || this.paramForm.get('sublineCd')?.value===null
        ||this.paramForm.get('planCd')?.value==='' || this.paramForm.get('planCd')?.value===null
        ||this.deductibleForm.get('deductibleCd')?.value==='' || this.deductibleForm.get('deductibleCd')?.value===null
        ||this.deductibleForm.get('activeTag')?.value==='' || this.deductibleForm.get('activeTag')?.value===null) {
        this.formService.showFormMsg("bfb-standard-rates-error-message", 'There are missing information. Please provide the necessary information needed.', "E");
        return false;
      }
      else {
        return true;
      }
   }
    catch (e) {
    console.error(e);
      return false;
    }
  }

  validateUpdate() {
    try {
      this.validated = false;
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                          
          this.formService.hideFormMsg("bfb-standard-rates-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  duplicateCheck() {
    try {
      let deductibleCd = this.deductibleForm.get('deductibleCd')?.value
      this.pubUserStdRatesCodeField = this.deductibleTblConfig.tblData.filter(function(e: any) {
        if(e.DEDUCTIBLE_CD==deductibleCd.trim()){
          return true
        }else{
          return false
        }
      });
      if(this.pubUserStdRatesCodeField=='' || this.pubUserStdRatesCodeField==null) {
        return true;
      } else {
        this.formService.showFormMsg("bfb-standard-rates-error-message", 'Deductible Code already exists. Please enter a different code.', "E");
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  } 
}
